export const HEADER_MENUS = {
    language: null,
    profile: null,
    mobile: null,
}
